// Serviço para gerenciar contas no Supabase
import { supabase } from '../lib/supabase';

export interface Conta {
  id: string;
  nome: string;
  cnpj: string | null;
  email: string | null;
  telefone: string | null;
  createdAt: string;
  updatedAt: string;
}

interface ContaDB {
  id: string;
  nome: string;
  cnpj: string | null;
  email: string | null;
  telefone: string | null;
  created_at: string;
  updated_at: string;
}

function contaDBToConta(contaDB: ContaDB): Conta {
  return {
    id: contaDB.id,
    nome: contaDB.nome,
    cnpj: contaDB.cnpj || null,
    email: contaDB.email || null,
    telefone: contaDB.telefone || null,
    createdAt: contaDB.created_at,
    updatedAt: contaDB.updated_at,
  };
}

// Buscar todas as contas
export async function getContas(): Promise<Conta[]> {
  try {
    const { data, error } = await (supabase as any)
      .from('contas')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) throw error;

    return (data || []).map(contaDBToConta);
  } catch (error) {
    console.error('[contasService] Erro ao buscar contas:', error);
    return [];
  }
}

// Buscar conta por ID
export async function getContaById(id: string): Promise<Conta | null> {
  try {
    const { data, error } = await (supabase as any)
      .from('contas')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;
    if (!data) return null;

    return contaDBToConta(data);
  } catch (error) {
    console.error('[contasService] Erro ao buscar conta:', error);
    return null;
  }
}
